"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const EngagementCalculating = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M5.684 10.3 3.358 7.973c2.061-2.22 4.903-3.656 8.094-3.804v3.292c-2.243.148-4.282 1.2-5.768 2.838ZM.007 15.508a12.879 12.879 0 0 1 2.64-6.694l2.346 2.346a9.577 9.577 0 0 0-1.713 4.657 1.643 1.643 0 0 1-3.273-.309Zm12.54-8.046c2.242.148 4.282 1.2 5.768 2.838l2.325-2.326c-2.06-2.22-4.902-3.656-8.093-3.804v3.292Zm6.46 3.698a9.577 9.577 0 0 1 1.713 4.656 1.643 1.643 0 1 0 3.273-.308 12.879 12.879 0 0 0-2.64-6.694l-2.346 2.346Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React.createElement("circle", { cx: 7.5, cy: 16.5, r: 1.5 }),
    /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 16.5, r: 1.5 }),
    /* @__PURE__ */ React.createElement("circle", { cx: 16.5, cy: 16.5, r: 1.5 })
  );
};
export default EngagementCalculating;
